import { createSelector } from 'reselect';
import moment from 'moment';
import { ALL_TRAFFIC, FILTERS_CACHE_EXPIRY } from '@utils/constants';
import { SCOPE } from './types';

const selector = (state) => state[SCOPE];

export const defaultFilterSelector = createSelector(
  selector,
  (state) => state.defaultFilters || [],
);

export const isCacheValidSelector = createSelector(
  selector,
  ({ dataCachedAt }) =>
    dataCachedAt && moment().diff(dataCachedAt, 'minutes') < FILTERS_CACHE_EXPIRY,
);

export const filtersSelector = createSelector(selector, (state) => state.filters);

export const allTrafficFilterSelector = createSelector(
  defaultFilterSelector,
  (defaultFilters) => defaultFilters.find((filter) => filter.name === ALL_TRAFFIC) || null,
);

export default selector;
